module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/png/load_data_de-76a294eb543abe3293c33aaab781b11e.png";